import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import ChinaAddressV4Data from '../../common/ChinaAddressV4Data.json'
import uploadoss from '@/components/uploadoss'

export default {
name: 'channelApply',
directives: {
TransferDom
},
components: {
Group,
XAddress,
Checklist,
Popup,
uploadoss,
Step,
StepItem,
CheckIcon,
},
data () {
return {
selectAddressData: ChinaAddressV4Data,
headSrc: [],
salesMethodsDatas: [
{methodsName: '实体店', isActive: false},
{methodsName: '网络销售', isActive: false},
{methodsName: '其他', isActive: false},
],
detailInfoData: {
realName: '', //真实姓名
province: '', //省
city: '', //市
salesWay: '', //销售方式‘，’隔开
shopAddress: '',  //网店地址
imagePath: '',    //图片‘，’隔开
basicSituation: '', //基本情况
address: [],
},
showSexOptions: false,
head: {
btnName: '+',
ossdata: [],
fileArr: [],
},
isShopkeeper: false,
step: 0,
shopStatus: true,
turnDown: false,
turnDownText: '',
endStep: '完成',
showSetp: true,
}
},
methods: {
getShopkeeper () {
this.$request.post('/userChannel/getUserChannel',{

}).then(data => {
if(data.code == 0){
if(data.obj != null){
if(data.obj.doneStatus == '0'){  //审核中
this.shopStatus = false
this.turnDown = false
this.step = 1
this.showSetp = true
}else if(data.obj.doneStatus == '1' && data.obj.auditStatus == '0'){  //审核不通过(驳回)
this.detailInfoData.realName = data.obj.realName
this.detailInfoData.province = data.obj.province
this.detailInfoData.city = data.obj.city
this.detailInfoData.basicSituation = data.obj.basicSituation
this.detailInfoData.shopAddress = data.obj.shopAddress
this.detailInfoData.address = [data.obj.province,data.obj.city]
data.obj.salesWay.slice(0,-1).split(',').forEach((item, index) => {
this.salesMethodsDatas.forEach((item2, index2) => {
if(item2.methodsName == item){
item2.isActive = true
}
})
})
data.obj.imagePath.slice(0,-1).split(',').forEach((item, index) => {
if(!!item){
let obj = {}
obj.imgUrl = item
this.headSrc.push(obj)
}
})

this.turnDown = true
this.turnDownText = data.obj.remark
this.step = 2
this.endStep = '驳回'
this.showSetp = true
}else if(data.obj.doneStatus == '1' && data.obj.auditStatus == '1'){  //审核通过
this.detailInfoData.realName = data.obj.realName
this.detailInfoData.province = data.obj.province
this.detailInfoData.city = data.obj.city
this.detailInfoData.basicSituation = data.obj.basicSituation
this.detailInfoData.shopAddress = data.obj.shopAddress
this.detailInfoData.address = [data.obj.province,data.obj.city]
data.obj.salesWay.slice(0,-1).split(',').forEach((item, index) => {
this.salesMethodsDatas.forEach((item2, index2) => {
if(item2.methodsName == item){
item2.isActive = true
}
})
})
data.obj.imagePath.slice(0,-1).split(',').forEach((item, index) => {
if(!!item){
let obj = {}
obj.imgUrl = item
this.headSrc.push(obj)
}
})


this.turnDownText = data.obj.remark
this.step = 3

this.showSetp = true
this.showBottomNav = true
this.isShopkeeper = true
}
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
onShadowChange () {
this.detailInfoData.province = this.$refs.addressArea.nameValue.split(' ')[0]
this.detailInfoData.city = this.$refs.addressArea.nameValue.split(' ')[1]
},

showossdataHead(data) {
this.ossdata = data;
console.log(this.ossdata);
},
showossurlHead(fileArr) {

this.$set(this.headSrc,this.headSrc.length,fileArr[0])
console.log(JSON.parse(JSON.stringify(this.headSrc)))

},
delImg (item, index) {
console.log(JSON.parse(JSON.stringify(this.headSrc)))
this.headSrc.splice(index,1)
},
submitShopInfo (url) {
delete this.detailInfoData.address
this.$request.post(url,this.detailInfoData).then(data => {
if(data.code == 0){
this.$vux.toast.show({
type: 'success',
text: '已提交，请等待审核'
})
this.getShopkeeper()
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
goHomePage () {
this.$router.push({
path: '/'
})
},
save () {

this.detailInfoData.imagePath = ''
this.detailInfoData.salesWay = ''
if(!this.$trim(this.detailInfoData.realName)){
this.$vux.toast.show({
type: 'warn',
text: '请输入真实姓名'
})
return false;
}

if(!this.$trim(this.detailInfoData.city)){
this.$vux.toast.show({
type: 'warn',
text: '请选择所在地区'
})
return false;
}

if(!this.$trim(this.detailInfoData.basicSituation)){
this.$vux.toast.show({
type: 'warn',
text: '请输入基本情况'
})
return false;
}

if(this.headSrc.length != 0){
this.headSrc.forEach((item, index) => {
this.detailInfoData.imagePath += item.imgUrl+','
})
}

this.salesMethodsDatas.forEach((item, index) => {
if(item.isActive){
this.detailInfoData.salesWay += item.methodsName+','
}
})

console.log(JSON.parse(JSON.stringify(this.detailInfoData)))

if(this.isShopkeeper){  //（修改）
this.submitShopInfo('/userChannel/userChannelApply')
}else{  //（申请）
this.submitShopInfo('/userChannel/userChannelApply')
}
}
},
computed: {

},
created () {
this.getShopkeeper()
},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/channelApply/script.js